import React from 'react';

import { SectionLabel } from './SectionLabel';
import { DateTimePicker } from '../../../../components/atoms/DateTimePicker';

export interface ScheduleFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  lockReason?: string;
  locked?: boolean;
}

export const ScheduleField: React.FC<ScheduleFieldProps> = ({
  value,
  onChange,
  disabled,
  lockReason,
  locked,
}) => (
  <SectionLabel label="Scheduled Date / Time" lockReason={lockReason} locked={locked}>
    <DateTimePicker
      label="Scheduled Date / Time"
      hideInlineLabel
      disablePast
      value={value}
      onChange={onChange}
      disabled={disabled || !!lockReason || !!locked}
    />
  </SectionLabel>
);
